export default class PrevadzkovaKnihaPrintModalCtrl {

  constructor($uibModalInstance){
    this.dialog = $uibModalInstance;
    var y = new Date().getFullYear();
    this.data =  {
        dateFrom: new Date(y+"-01-01"),
        dateTo: new Date(y+"-12-31")
    }
  } 

  ok(){
    this.dialog.close(this.data);
  }

  cancel(){
    this.dialog.dismiss("cancel");
  }
}


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/PrevadzkovaKnihaPrintModalCtrl.js